export class SearchPagerModel {
	search: string;
	skip: number;
	take: number;
	currentPage: number;
	sortDir: string;
	sortField: string;
}
